import { useAnchorable } from '../../hooks/useAnchorable';
import {
  button,
  contentContainer,
  imageContainer,
  recommendationContainer,
  recommendationInnerContainer,
  subtitle,
} from './Recommendation.css';
import type { TPostRecommendationProps } from './Recommendation.types';

export const PostRecommendation = (props: TPostRecommendationProps) => {
  const { element, rewriteImageSrc, isIndexingDisabled } = props;
  const { attrs } = element;
  const { anchorAttributes } = useAnchorable(attrs);

  const { recommended_publication: recommendedPublication } = attrs?.data || {};
  if (!attrs.data) {
    return null;
  }

  const logoUrl =
    rewriteImageSrc && recommendedPublication?.logo_url
      ? rewriteImageSrc(recommendedPublication.logo_url)
      : recommendedPublication?.logo_url;

  return (
    <div {...anchorAttributes} className={recommendationContainer}>
      <div className={recommendationInnerContainer}>
        <div className="flex">
          <div className={imageContainer}>
            <img alt={recommendedPublication?.name} src={logoUrl} className="w-full h-full object-cover" />
          </div>
          <div className={contentContainer}>
            <p>{recommendedPublication?.name}</p>
            <p className={subtitle}>{recommendedPublication?.description}</p>
          </div>
        </div>
        <a
          href={recommendedPublication?.subscribe_url}
          rel={isIndexingDisabled ? 'nofollow noopener' : undefined}
          className="w-full"
          target="_blank"
          data-skip-tracking="true"
        >
          <button type="button" className={button}>
            Subscribe
          </button>
        </a>
      </div>
    </div>
  );
};
